import _ from 'lodash';
import { sleep } from '@/utilities';

const makeInitialState = () => ({
  messages: [],
});

const mutations = {
  CREATE(state, payload) {
    state.messages.push(payload);
  },
  CLEAR(state, { id }) {
    state.messages = _.reject(state.messages, { id });
  },
};

const actions = {
  async flashMessage({ commit }, payload) {
    const { msg, msgType } = { msgType: 'info', ...payload };
    const id = _.uniqueId();
    commit('CREATE', { msg, msgType, id });
    await sleep(10000);
    commit('CLEAR', { id });
  },
  clearMessage({ commit }, payload) {
    commit('CLEAR', payload);
  },
};

export default {
  namespaced: true,
  state: makeInitialState,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/Notifications.js